<template>
  <TableGradient
      icon-name="pills"
      :title="$t('loinc.listagem.titulo_pagina')"
      :text-empty="$t('loinc.listagem.table.empty')"
      route-new="loinc.create"
      :text-new="$t('loinc.listagem.novo')"
      :fields="fields"
      :items="loincs"
      :loading="isLoading"
      :paginator="pagination"
      @list="evt => $store.dispatch('loinc/listAll', evt)"
  >
    <template v-slot:cell(long_common_name)="linha">
      <p class="m-0 small" v-if="linha.item.long_common_name">
        <span class="font-weight-bold">{{ $t('loinc.listagem.table.nome_longo') }}:</span> {{ linha.item.long_common_name }}
      </p>
      <p class="m-0 pt-2 small" v-if="linha.item.short_name">
        <span class="font-weight-bold">{{ $t('loinc.listagem.table.nome_curto') }}:</span> {{ linha.item.short_name }}
      </p>
      <p class="m-0 pt-2 small" v-if="linha.item.long_common_name">
        <span class="font-weight-bold">{{ $t('loinc.listagem.table.nome_exibicao') }}:</span> {{ linha.item.display_name }}
      </p>
    </template>
    <template v-slot:cell(component)="linha">
      <p class="m-0 small" v-if="linha.item.component">
        <span class="font-weight-bold">{{ $t('loinc.listagem.table.componente') }}:</span> {{ linha.item.component }}
      </p>
      <p class="m-0 pt-2 small" v-if="linha.item.time">
        <span class="font-weight-bold">{{ $t('loinc.listagem.table.tempo') }}:</span> {{ linha.item.time }}
      </p>
      <p class="m-0 pt-2 small" v-if="linha.item.scale">
          <span class="font-weight-bold">{{ $t('loinc.listagem.table.escala') }}:</span> {{ linha.item.scale }}
      </p>
      <p class="m-0 pt-2 small" v-if="linha.item.method">
        <span class="font-weight-bold">{{ $t('loinc.listagem.table.metodo') }}:</span> {{ linha.item.method }}
      </p>
    </template>
    <template v-slot:cell(status_name)="linha">
      <span
          :class="{'rounded-pill p-1 badge':true, 'badge-success':linha.item.status, 'badge-danger': !linha.item.status}">
          <em>{{ linha.item.status_name }}</em>
      </span>
    </template>
    <template v-slot:cell(id)="linha">
      <router-link :id="'link-edit-' + linha.index" :to="{ name: 'loinc.edit', params: { id: linha.item.id }}"
                   class="font-weight-bold">
        {{ $t('loinc.listagem.table.editar') }}
      </router-link>
    </template>
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "Index",
  components: {TableGradient},
  computed: {
    ...mapGetters({
      loincs: 'loinc/all',
      store_isLoading: 'loinc/isLoading',
      pagination: 'loinc/pagination'
    }),
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [
        {key: 'loinc', label: 'LOINC', sortable: true},
        {key: 'long_common_name', label: this.$t('loinc.listagem.table.nome'), sortable: true},
        {key: 'component', label: this.$t('loinc.listagem.table.componente'), sortable: true},
        {key: 'property', label: this.$t('loinc.listagem.table.propriedade'), sortable: true},
        {key: 'system', label: this.$t('loinc.listagem.table.sistema'), sortable: true},
        {key: 'order_observation_name', label: this.$t('loinc.listagem.table.ordem_observacao'), sortable: true},
        {key: 'status_name', label: 'Status', sortable: true},
        {key: 'id', label: this.$t('loinc.listagem.table.editar')},
      ]
    }
  },
  methods: {
    ...mapActions([
      'loinc/listAll'
    ])
  },
  mounted() {
    this['loinc/listAll'](this.pagination)
    this.mounted = true
  }
}
</script>

<style lang="scss" scoped>
</style>
